/** @jsxImportSource @emotion/react */
import styled from '@emotion/styled'
import { ButtonHTMLAttributes, FC } from 'react'
import { StyledCloseBtn } from '../CloseBtn'
import { RevertIcon } from '../Icons'

export const StyledRevertBtn = styled(StyledCloseBtn)`
  border: 1px solid rgba(255, 255, 255, 0.07);
  background: rgba(123, 123, 123, 0.3);
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 4px 4px 0 rgba(0, 0, 0, 0.05),
    0 10px 10px 0 rgba(0, 0, 0, 0.1);

  &:hover {
    background: rgba(123, 123, 123, 0.5);
    border-color: rgba(255, 255, 255, 0.15);
    box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.05), 0 4px 4px 0 rgba(0, 0, 0, 0.05),
      0 10px 10px 0 rgba(0, 0, 0, 0.1), 0 0 10px 0 rgba(123, 123, 123, 0.4);
  }
`

export const RevertBtn: FC<ButtonHTMLAttributes<HTMLButtonElement>> = (
  props
) => {
  return (
    <StyledRevertBtn {...props}>
      <RevertIcon
        color="white"
        size={{
          mobile: '5px',
          tablet: '9px',
          desktop: '9px',
        }}
      />
    </StyledRevertBtn>
  )
}
